const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
   <style>
        .container {
            display: flex;
            flex-direction: column;
            padding-top: 60px;
            justify-content: center;
            align-items: center;
        }
        .container h3 {
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            color: #424242;
            margin: 0;
        }
        .container p {
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #7F7F7F;
            margin: 0;
        }
        .container .button-login {
            display: flex;
            margin-top: 16px;
            padding: 12px 50px;
            background-color: #3570D2;
            border-radius: 5px;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 16px;
            line-height: 135%;
            color: #FFFFFF;
            cursor: pointer;
        }
   </style>
 </template>`;

styleElement.register("ecourse-empty-content-style");
